<template>
  <div>
    <AddBarForm :bar="bar" :formTitle="formTitle" :submit="submit" />
  </div>
</template>
<script>
import AddBarForm from "../components/AddBarForm";
import addBarMutation from "../gql/addBarMutation";
import { formatPrices, defaultBar } from "../utils";
export default {
  components: {
    AddBarForm
  },
  data: function() {
    return {
      formTitle: "Add Bar",
      bar: Object.assign({}, defaultBar)
    };
  },
  methods: {
    submit(bar) {
      this.$apollo
        .mutate({
          mutation: addBarMutation,
          variables: {
            name: bar.name,
            description: bar.description,
            hours: bar.hours,
            address: bar.address,
            imageURLs: bar.imageURLs,
            dailySpecials: bar.dailySpecials,
            happyHours: bar.happyHours,
            prices: formatPrices(bar.prices),
            categories: bar.categories,
            featured: bar.featured,
            published: bar.published
          }
        })
        .then(({ data: { addBar } }) => {
          if (addBar) {
            this.$store.commit({ type: "addBar", payload: addBar });
          }
          this.$router.push("all-bars");
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style lang="scss"></style>
